import React, { useRef, useState, useEffect, useCallback } from 'react';
import Webcam from "react-webcam";
import { BrowserMultiFormatReader } from "@zxing/library";
import API from "../../../../ApiConfig";
import { GET_QR_SHARED_DATA } from '../../../../Utils/constant';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../../components/Loader';
import styles from '../../ExternalDash/Verifier/Records.module.css';

const QrReader = () => {
    const webcamRef = useRef(null);
    const [error, setError] = useState(null);
    const [scanned, setScanned] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const [shared_data_id, setSharedId] = useState("");
    const navigate = useNavigate();
    const codeReader = useRef(new BrowserMultiFormatReader());

    const captureFrame = useCallback(async () => {
        if (webcamRef.current) {
            const imageSrc = webcamRef.current.getScreenshot();
            if (imageSrc) {
                try {
                    const result = await codeReader.current.decodeFromImage(undefined, imageSrc);
                    if (result && !scanned) {
                        setScanned(true);
                        handleScan(result.getText());
                    }
                } catch (err) {
                    // Do nothing if no QR code is found
                }
            }
        }
    }, [scanned]);

    useEffect(() => {
        if (!scanned) {
            const interval = setInterval(() => {
                captureFrame();
            }, 500); // Check every 500ms

            return () => clearInterval(interval); // Cleanup on unmount
        }
    }, [scanned, captureFrame]);

    const getDetails = (verifier_id, holder_data_uuid, shared_data_id) => {
        setLoading(true);
        API.get(GET_QR_SHARED_DATA + verifier_id + '/' + holder_data_uuid + '/' + shared_data_id)
            .then(res => {
                if (res.data.status === 200) {
                    setLoading(false);
                    setData(res.data.data);
                    // console.log(res.data.data);
                } else {
                    setError("An error occurred");
                }
            })
            .catch(err => {
                setError(err?.response?.data?.message);
                // console.log(err);
            });
    };

    const handleScan = (dataString) => {
        let verifier_id, holder_data_uuid, shared_data_id;
        // console.log(dataString);

        try {
            if (dataString.startsWith("http://") || dataString.startsWith("https://")) {
                const url = new URL(dataString);
                verifier_id = url.searchParams.get("verifier_id");
                holder_data_uuid = url.searchParams.get("holder_data_uuid");
                shared_data_id = url.searchParams.get("shared_data_id");
            } else {
                const parsedData = JSON.parse(dataString.replace(/'/g, '"'));
                verifier_id = parsedData.verifier_id;
                holder_data_uuid = parsedData.holder_data_uuid;
                shared_data_id = parsedData.shared_data_id;
            }

            if (verifier_id && holder_data_uuid && shared_data_id) {
                setSharedId(shared_data_id);
                getDetails(verifier_id, holder_data_uuid, shared_data_id);
            }
        } catch (error) {
            console.error("Error parsing QR code", error);
        }
    };

    return (
        <>
            <Loader loading={loading} />
            <div className={styles.qrContainer}>
                {!scanned ?
                    <>
                        <div>
                            <img src='/qrscan.svg' alt='qrscan.svg' style={{ width: "50px", height: "50px" }} />
                        </div>
                        <div className={styles.qrText}>Scan QR code</div>
                        <span className={styles.qrSubText}>Scan the user QR here to fetch the details</span>
                        <Webcam
                            audio={false}
                            ref={webcamRef}
                            screenshotFormat="image/png"
                            videoConstraints={{ facingMode: "environment" }}
                            className={styles.qrScanner}
                        />
                        {error && <p style={{ color: "red", fontSize: "18px" }}>{error}</p>}
                    </>
                    :
                    <table style={{ width: '100%', textAlign: 'left' }}>
                        <tbody>
                            {data && data.map((item, index) => (
                                <>
                                    <div className={styles.button} onClick={() => setScanned(false)} style={{ border: "1px solid #D0D5DD", padding: "10px", backgroundColor: "white" }}>
                                        <img className={styles.arrowLeftIcon} loading="eager" alt="" src="/arrowleft.svg" />
                                    </div>
                                    <tr key={index} style={{ display: "flex", alignItems: 'center', justifyContent: "space-evenly" }}>
                                        <div className="heading">{loading ? <div className="shimmer" style={{ width: '10rem' }} /> : item.holder_name}</div>
                                        <button className='btn btn-primary' style={{ width: "11%" }} onClick={() => navigate('../forms/faceMatch', { state: { shared_data_id: shared_data_id } })}>Verify face</button>
                                    </tr>
                                    <tr>
                                        <td className="credentials-td" style={{ justifyContent: 'flex-start' }}>
                                            <table border="1" style={{ width: "100%", borderCollapse: "collapse" }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{ backgroundColor: "lightgray", padding: "10px" }}>Doc Field Name</th>
                                                        <th style={{ backgroundColor: "lightgray", padding: "10px" }}>Consented Data</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data.map((holder, index) =>
                                                        holder.form_data.map((formItem, subIndex) => (
                                                            <tr key={`${index}-${subIndex}`} style={{ padding: "10px" }}>
                                                                <td style={{ padding: "10px" }}>{formItem.doc_field_name}</td>
                                                                <td style={{ padding: "10px" }}>{formItem.consented_data?.includes("http") || formItem.consented_data?.includes("data:image") || formItem.consented_data.includes("localhost") ? (
                                                                    <img
                                                                        src={formItem.consented_data}
                                                                        alt="Document"
                                                                        style={{ width: "100px", height: "100px", objectFit: "cover" }}
                                                                        loading='lazy'
                                                                        onError={(e) => (e.target.src = "/avatar@2x.png")} // Fallback image
                                                                    />
                                                                ) : (
                                                                    formItem.consented_data // Render as text if not an image
                                                                )}</td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </>
                            ))}
                        </tbody>
                    </table>
                }

            </div>
        </>
    );
};

export default QrReader;
